export default __webpack_public_path__ + "static/footerx2-fb6ae41b8d1274ba1775896a39617024.png";